import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-aged-receivables-details',
  standalone: false,
  
  templateUrl: './sales-aged-receivables-details.component.html',
  styles: ``
})
export class SalesAgedReceivablesDetailsComponent {

}
